(() => {
  const initialized = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getWrap(drawer) {
    return drawer.querySelector('.vena-contact-offers__answer-wrap');
  }

  function stopAnimation(drawer) {
    const wrap = getWrap(drawer);
    if (!wrap) return;
    wrap.getAnimations().forEach((animation) => animation.cancel());
    wrap.style.height = '';
    drawer.classList.remove('is-opening', 'is-closing');
  }

  function closeDrawer(drawer, immediate = false) {
    if (!drawer.open) return;
    const wrap = getWrap(drawer);
    if (!wrap || immediate || reduceMotion.matches) {
      drawer.open = false;
      stopAnimation(drawer);
      return;
    }

    stopAnimation(drawer);
    drawer.classList.add('is-closing');
    wrap.style.height = `${wrap.offsetHeight}px`;

    requestAnimationFrame(() => {
      wrap.style.height = '0px';
    });

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      wrap.removeEventListener('transitionend', onEnd);
      drawer.open = false;
      wrap.style.height = '';
      drawer.classList.remove('is-closing');
    };
    wrap.addEventListener('transitionend', onEnd);
  }

  function openDrawer(drawer, immediate = false) {
    if (drawer.open && !drawer.classList.contains('is-closing')) return;
    const wrap = getWrap(drawer);
    if (!wrap || immediate || reduceMotion.matches) {
      drawer.open = true;
      stopAnimation(drawer);
      return;
    }

    stopAnimation(drawer);
    drawer.open = true;
    drawer.classList.add('is-opening');
    wrap.style.height = '0px';

    requestAnimationFrame(() => {
      wrap.style.height = `${wrap.scrollHeight}px`;
    });

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      wrap.removeEventListener('transitionend', onEnd);
      wrap.style.height = '';
      drawer.classList.remove('is-opening');
    };
    wrap.addEventListener('transitionend', onEnd);
  }

  function init(group) {
    if (initialized.has(group)) return;
    initialized.add(group);

    const drawers = Array.from(group.querySelectorAll('.vena-contact-offers__item'));
    if (!drawers.length) return;

    drawers.forEach((drawer, index) => {
      if (index === 0) {
        drawer.open = true;
      } else {
        drawer.open = false;
      }

      const summary = drawer.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (drawer.open && !drawer.classList.contains('is-closing')) {
          closeDrawer(drawer);
          return;
        }

        drawers.forEach((other) => {
          if (other !== drawer) closeDrawer(other);
        });
        openDrawer(drawer);
      });
    });
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-vena-contact-offers]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
